import React, { FC } from 'react';
import Svg, { Ellipse, G, Line, Path, Rect, Text as SvgText } from 'react-native-svg';
import { AnnotationType, ToolIconName } from '@v2/components/imageHandling/components/DrawingCanvas/types';
import { ERASER_TOOL, POINTER_TOOL } from '@v2/components/imageHandling/components/DrawingCanvas/constants';

interface ToolIconProps {
  name: ToolIconName;
  color: string;
  size: number;
}

const ToolIcon: FC<ToolIconProps> = ({ name, color, size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {name === POINTER_TOOL ? (
        <Path d="M5,3 L5,20 L9,16 L12,22 L14.5,21 L11.5,15 L17,15 L5,3 Z" fill={color} stroke={color} strokeWidth={0.5} strokeLinejoin="round" />
      ) : null}
      {name === AnnotationType.Pen ? (
        <Path
          d="M3,17.25 L3,21 L6.75,21 L17.81,9.94 L14.06,6.19 L3,17.25 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 Z"
          fill={color}
        />
      ) : null}
      {name === AnnotationType.Highlighter ? (
        <G>
          <Path d="M4,19 L8,19 L20,7 L16,3 L4,15 Z" fill="none" stroke={color} strokeWidth={2} />
          <Line x1={2} y1={22} x2={10} y2={22} stroke={color} strokeWidth={2} strokeLinecap="round" />
        </G>
      ) : null}
      {name === ERASER_TOOL ? (
        <G>
          <Path d="M20,7 L9,18 L3.5,18 L2,16.5 L8,7 L20,7 Z" fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" />
          <Line x1={2} y1={22} x2={22} y2={22} stroke={color} strokeWidth={2} />
        </G>
      ) : null}
      {name === AnnotationType.Arrow ? (
        <Path d="M5,19 L19,5 M19,5 L12,5 M19,5 L19,12" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      ) : null}
      {name === AnnotationType.Rectangle ? <Rect x={4} y={6} width={16} height={12} fill="none" stroke={color} strokeWidth={2} rx={1} /> : null}
      {name === AnnotationType.Circle ? <Ellipse cx={12} cy={12} rx={9} ry={7} fill="none" stroke={color} strokeWidth={2} /> : null}
      {name === AnnotationType.Text ? (
        <SvgText x={5} y={19} fontSize={20} fontWeight="bold" fill={color} fontFamily="sans-serif">
          T
        </SvgText>
      ) : null}
      {name === 'undo' ? (
        <Path
          d="M9,4 L4,9 L9,14 M4,9 L16,9 C19,9 21,11 21,14 C21,17 19,19 16,19 L12,19"
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
      {name === 'redo' ? (
        <Path
          d="M15,4 L20,9 L15,14 M20,9 L8,9 C5,9 3,11 3,14 C3,17 5,19 8,19 L12,19"
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
      {name === 'check' ? <Path d="M5,12 L10,17 L19,7" fill="none" stroke={color} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" /> : null}
      {name === 'close' ? <Path d="M6,6 L18,18 M18,6 L6,18" fill="none" stroke={color} strokeWidth={2.5} strokeLinecap="round" /> : null}
      {name === 'trash' ? (
        <G>
          <Path d="M4,7 L20,7 M9,7 L9,4 L15,4 L15,7 M6,7 L7,20 L17,20 L18,7" fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
          <Line x1={10} y1={11} x2={10} y2={17} stroke={color} strokeWidth={2} strokeLinecap="round" />
          <Line x1={14} y1={11} x2={14} y2={17} stroke={color} strokeWidth={2} strokeLinecap="round" />
        </G>
      ) : null}
    </Svg>
  );
};

export default ToolIcon;
